(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klinker-documentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const ready = fn => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  ready(() => document.querySelectorAll('[data-kd]').forEach(init));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kd]').forEach(init));
  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const admin = root.dataset.role === 'admin';
    const strings = JSON.parse(root.querySelector('[data-i18n]').textContent);
    const t = key => strings[key] || strings.server_error;
    const find = selector => root.querySelector(selector);
    const message = find('[data-message]');
    const login = find('[data-login]');
    const editor = find('[data-editor]');
    const form = find('[data-report-form]');
    const keyInput = document.getElementById('kat-key');
    const refInput = document.getElementById('kat-ref');
    let report = null, reference = '', credential = '', dirty = false, busy = false, generation = 0;
    let api;
    try { api = new URL(root.dataset.api); if (api.protocol !== 'https:') throw new Error(); api = api.href.replace(/\/$/, ''); }
    catch (_) { api = ''; }
    const objectURLs = new Set();
    const thumbCache = new Map();
    let disabledState = [];
    const say = (key, error = false, suffix = '') => {
      message.textContent = t(key) + suffix;
      message.dataset.error = String(error);
    };
    const showLogin = value => { if (login) login.hidden = !value; };
    const clearMedia = () => {
      generation++;
      for (const url of objectURLs) URL.revokeObjectURL(url);
      objectURLs.clear(); thumbCache.clear();
    };
    const setBusy = value => {
      busy = value; root.setAttribute('aria-busy', String(value));
      if (value) {
        const controls = [...root.querySelectorAll('button,input,textarea'), keyInput, refInput].filter(Boolean);
        disabledState = controls.map(el => [el, el.disabled]);
        controls.forEach(el => { el.disabled = true; });
      } else { disabledState.forEach(([el, previous]) => { el.disabled = previous; }); disabledState = []; }
    };
    async function request(suffix = '', options = {}, raw = false) {
      const response = await fetch(`${api}/v1/${admin ? 'admin' : 'shared'}/reports/${encodeURIComponent(reference)}${suffix}`, {
        ...options, credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store',
        headers: {...options.headers, Authorization: `Bearer ${credential}`}, signal: AbortSignal.timeout(90000)
      });
      if (raw && response.ok) return response.blob();
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(result.error || 'server_error');
      return result.report;
    }
    async function perform(fn) {
      if (busy) return;
      if (!api) { say('not_configured', true); return; }
      setBusy(true);
      try { await fn(); }
      catch (error) { say(strings[error.message] ? error.message : 'server_error', true); message.focus(); }
      finally { setBusy(false); }
    }
    function readFields() {
      const data = {vin: '', before: {}, after: {}};
      root.querySelectorAll('[data-field]').forEach(input => {
        const [stage, key] = input.dataset.field.split('.');
        if (!key) data[stage] = input.value.trim().toUpperCase();
        else data[stage][key] = key === 'mileage' ? input.value === '' ? null : Number(input.value) : input.value.trim();
      });
      return data;
    }
    async function save() {
      if (!report) throw new Error('not_loaded');
      const temporarilyEnabled = [...form.querySelectorAll('input:disabled,textarea:disabled')];
      temporarilyEnabled.forEach(input => { input.disabled = false; });
      const valid = form.reportValidity();
      temporarilyEnabled.forEach(input => { input.disabled = true; });
      if (!valid) throw new Error('invalid_data');
      say('saving');
      const data = readFields();
      const result = await request('', {method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify({version: report.version, data})});
      dirty = false; render(result, true);
    }
    function valueAt(data, path) { return path.split('.').reduce((value, key) => value?.[key], data); }
    function formatDate(value) { return value ? new Date(value).toLocaleString('da-DK', {dateStyle:'short', timeStyle:'short'}) : ''; }
    function render(next, fillFields) {
      report = next;
      showLogin(false);
      editor.hidden = false;
      find('[data-reference]').textContent = report.reference;
      find('[data-vehicle]').textContent = report.vehicle;
      find('[data-route]').textContent = `${report.pickup} → ${report.destination}`;
      if (fillFields) root.querySelectorAll('[data-field]').forEach(input => { input.value = valueAt(report.data, input.dataset.field) ?? ''; });
      root.querySelectorAll('[data-value]').forEach(el => { el.textContent = valueAt(report.data, el.dataset.value) ?? t('missing'); if (!el.textContent) el.textContent = t('missing'); });
      const before = report.data.before?.mileage, after = report.data.after?.mileage;
      find('[data-distance]').textContent = before != null && after != null ? `${(after-before).toLocaleString('da-DK')} ${t('km')}` : '—';
      if (admin) {
        find('[data-saved-at]').textContent = report.version ? `${t('updated')}: ${formatDate(report.updatedAt)}` : '';
        const share = find('[data-share-link]');
        const hasLink = Boolean(report.shareToken);
        share.hidden = !hasLink; find('[data-copy]').hidden = !hasLink; find('[data-revoke]').hidden = !hasLink; find('[data-share]').hidden = hasLink;
        if (hasLink) { const link = new URL('/pages/tracking', location.origin); link.searchParams.set('tracking', reference); link.hash = `doc=${report.shareToken}`; share.value = link.href; }
        else share.value = '';
      }
      root.querySelectorAll('[data-count]').forEach(el => { el.textContent = `${report.media.filter(file => file.stage === el.dataset.count).length} ${t('photos')}`; });
      observer?.disconnect();
      root.querySelectorAll('[data-card]').forEach(card => {
        const [stage, category] = card.dataset.card.split('.');
        const gallery = card.querySelector('[data-gallery]');
        gallery.replaceChildren();
        const files = report.media.filter(file => file.stage === stage && file.category === category);
        if (!files.length) { const empty = document.createElement('p'); empty.className = 'kd-empty'; empty.textContent = t('empty'); gallery.append(empty); }
        for (const file of files) addPhoto(gallery, file);
      });
    }
    async function mediaURL(file) {
      if (!thumbCache.has(file.id)) {
        const currentGeneration = generation;
        const promise = request(`/media/${file.id}`, {}, true).then(blob => {
          if (currentGeneration !== generation) throw new Error('not_loaded');
          const url = URL.createObjectURL(blob); objectURLs.add(url); return url;
        }).catch(error => { thumbCache.delete(file.id); throw error; });
        thumbCache.set(file.id, promise);
      }
      return thumbCache.get(file.id);
    }
    let activeThumbnails = 0;
    const thumbnailQueue = [];
    function drain() {
      while (activeThumbnails < 3 && thumbnailQueue.length) {
        const task = thumbnailQueue.shift();
        if (!task.figure.isConnected) continue;
        activeThumbnails++;
        task.run().finally(() => { activeThumbnails--; drain(); });
      }
    }
    const observer = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) { observer.unobserve(entry.target); thumbnailQueue.push({figure:entry.target, run:entry.target.loadPhoto}); drain(); }
    }, {rootMargin:'100px'}) : null;
    function addPhoto(gallery, file) {
      const figure = document.createElement('figure'); figure.className = 'kd-photo';
      const link = document.createElement('a'); link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = t('view');
      if (file.mime === 'application/pdf') { link.className = 'kd-pdf'; link.textContent = 'PDF ↓'; }
      const caption = document.createElement('figcaption'); caption.textContent = formatDate(file.uploaded_at);
      figure.append(link, caption);
      figure.loadPhoto = async () => {
        try {
          const url = await mediaURL(file);
          if (!figure.isConnected) return;
          link.href = url;
          if (file.mime === 'application/pdf') link.download = `${reference}-${file.stage}-papirer.pdf`;
          else { const img = document.createElement('img'); img.src = url; img.alt = `${t('category_'+file.category)} — ${t(file.stage)}`; img.loading = 'lazy'; link.replaceChildren(img); }
        } catch (_) { link.textContent = t('photo_error'); }
      };
      link.addEventListener('click', event => { if (!link.href) { event.preventDefault(); figure.loadPhoto(); } });
      if (admin) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'kd-button'; button.textContent = t('remove');
        button.addEventListener('click', () => {
          if (busy) return;
          if (!confirm(t('remove_confirm'))) return;
          perform(async () => { const next = await request(`/media/${file.id}`, {method:'DELETE'}); render(next, false); say('saved'); });
        });
        figure.append(button);
      }
      gallery.append(figure);
      if (observer) observer.observe(figure); else { thumbnailQueue.push({figure, run:figure.loadPhoto}); drain(); }
    }
    async function compatibleFile(file) {
      if (file.size > 20*1024*1024) throw new Error('file_too_large');
      if (!/\.(heic|heif)$/i.test(file.name) && !/heic|heif/.test(file.type)) return file;
      const url = URL.createObjectURL(file);
      try {
        const img = new Image(); img.src = url; await img.decode();
        if (img.naturalWidth * img.naturalHeight > 60000000) throw new Error();
        const canvas = document.createElement('canvas'); canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', .94));
        if (!blob) throw new Error();
        if (blob.size > 20*1024*1024) throw new Error('file_too_large');
        return blob;
      } catch (error) { throw new Error(error.message === 'file_too_large' ? error.message : 'unsupported_file'); }
      finally { URL.revokeObjectURL(url); }
    }
    if (admin) {
      form.addEventListener('input', () => { dirty = true; });
      window.addEventListener('beforeunload', event => { if (dirty || busy) { event.preventDefault(); event.returnValue = ''; } });
      const discard = () => !dirty || confirm(t('unsaved'));
      const openReport = () => {
        if (!discard()) {
          if (refInput && reference) refInput.value = reference;
          return;
        }
        const key = keyInput?.value.trim();
        const ref = refInput?.value.trim().toUpperCase();
        if (!key || !/^KL-\d{5,10}$/.test(ref || '')) { say('credentials', true); return; }
        perform(async () => {
          reference = ref; credential = key; report = null; dirty = false; editor.hidden = true; clearMedia(); say('loading');
          render(await request('/open', {method:'POST'}), true); message.textContent = '';
        });
      };
      const openButton = find('[data-open]');
      openButton?.addEventListener('click', openReport);
      document.addEventListener('klinker:admin-transport-selected', event => {
        if (!admin) return;
        const selected = String(event.detail?.reference || '').trim().toUpperCase();
        if (!/^KL-\d{5,10}$/.test(selected)) return;
        if (refInput) refInput.value = selected;
        openReport();
      });
      refInput?.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        openReport();
      });
      for (const input of [keyInput, refInput]) input?.addEventListener('input', () => {
        if (dirty) {
          if (!discard()) {
            if (input === refInput && reference) refInput.value = reference;
            if (input === keyInput && credential) keyInput.value = credential;
            return;
          }
          dirty = false;
        }
        editor.hidden = true; report = null; credential = ''; clearMedia();
        say('not_loaded');
      });
      form.addEventListener('submit', event => { event.preventDefault(); perform(async () => { await save(); say('saved'); }); });
      root.querySelectorAll('[data-pick]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.pick).click()));
      root.querySelectorAll('[data-upload]').forEach(input => input.addEventListener('change', () => {
        const files = Array.from(input.files || []);
        if (!files.length) return;
        perform(async () => {
          if (!report) throw new Error('not_loaded');
          if (dirty) await save();
          let completed = 0;
          for (const file of files) {
            say('uploading', false, ` ${++completed}/${files.length}…`);
            const body = await compatibleFile(file);
            const query = new URLSearchParams({stage: input.dataset.stage, category: input.dataset.category});
            render(await request(`/media?${query}`, {method:'POST', headers:{'Content-Type':'application/octet-stream'}, body}), false);
          }
          input.value = ''; say('uploaded');
        });
      }));
      find('[data-share]').addEventListener('click', () => perform(async () => {
        if (dirty) await save();
        render(await request('/share', {method:'POST'}), false); say('share_ready');
      }));
      find('[data-copy]').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(find('[data-share-link]').value); say('copied'); }
        catch (_) { find('[data-share-link]').focus(); find('[data-share-link]').select(); }
      });
      find('[data-revoke]').addEventListener('click', () => {
        if (!confirm(t('revoke_confirm'))) return;
        perform(async () => { render(await request('/share', {method:'DELETE'}), false); say('share_revoked'); });
      });
      if (!api) { say('not_configured'); editor.hidden = false; find('[data-fields]').disabled = true; root.querySelectorAll('button').forEach(button => { button.disabled = true; }); }
    } else {
      const initialReference = new URLSearchParams(location.search).get('tracking')?.trim().toUpperCase();
      const sharedToken = new URLSearchParams(location.hash.slice(1)).get('doc');
      async function load(ref) {
        clearMedia(); editor.hidden = true; reference = ref || ''; credential = sharedToken || '';
        if (!api || reference !== initialReference || !/^KL-\d{5,10}$/.test(reference) || !/^[a-f0-9]{64}$/.test(credential)) { showLogin(true); say('locked'); return; }
        showLogin(false);
        const sequence = generation;
        say('loading');
        try { const next = await request(); if (sequence !== generation) return; render(next, true); message.textContent = ''; }
        catch (error) { if (sequence === generation) { showLogin(true); say(strings[error.message] ? error.message : 'server_error', true); } }
      }
      load(initialReference);
      document.addEventListener('klinker:tracking', event => load(event.detail.reference));
    }
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klinker-page-business"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-business-portal]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';

    const proxyBase = root.dataset.proxyBase;
    const statusNode = root.querySelector('[data-business-status]');
    const activeNode = root.querySelector('[data-business-active]');
    const previousNode = root.querySelector('[data-business-previous]');
    const labels = {
      front: 'Front', rear: 'Bagende', left: 'Venstre side', right: 'Højre side',
      roof: 'Tag', wheel_fl: 'Venstre forhjul', wheel_fr: 'Højre forhjul',
      wheel_rl: 'Venstre baghjul', wheel_rr: 'Højre baghjul',
      odometer: 'Kilometertæller', vin: 'VIN / stelnummer', documents: 'Dokument',
      accessories: 'Tilbehør', damage: 'Skade'
    };

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const api = async (path, options = {}) => {
      const response = await fetch(proxyBase + path, {
        method: options.method || 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
        cache: 'no-store',
        body: options.body ? JSON.stringify(options.body) : undefined
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.ok !== true) {
        const error = new Error(data.error || 'Kunne ikke hente oplysningerne');
        error.status = response.status;
        throw error;
      }
      return data;
    };

    const field = (label, value) => {
      const item = el('div', 'kbl-field');
      item.append(el('small', '', label), el('strong', '', value || '—'));
      return item;
    };

    const bookingRoot = root.querySelector('[data-business-booking]');
    const bookingForm = root.querySelector('[data-business-booking-form]');
    let routeQuote = null;
    let dashboardProfile = null;

    const bookingPayload = () => {
      const form = new FormData(bookingForm);
      const value = name => String(form.get(name) || '').trim();
      return {
        customerName: value('customerName'),
        company: value('company'),
        phone: value('phone'),
        vehicle: value('vehicle'),
        vin: value('vin').toUpperCase(),
        registered: value('registered') === 'Ja' ? 'Ja' : 'Nej',
        pickup: routeQuote?.pickup || value('pickup'),
        destination: routeQuote?.destination || value('destination'),
        requestedPickup: value('requestedPickup'),
        distanceKm: routeQuote?.distanceKm ?? null,
        estimatedPrice: routeQuote?.estimatedPrice ?? null
      };
    };

    const initBusinessBooking = () => {
      if (!bookingRoot || !bookingForm) return;
      const calculate = bookingRoot.querySelector('[data-business-calculate]');
      const submit = bookingRoot.querySelector('[data-business-submit]');
      const message = bookingRoot.querySelector('[data-business-booking-message]');
      const price = bookingRoot.querySelector('[data-business-price]');
      const receipt = bookingRoot.querySelector('[data-business-receipt]');
      const token = bookingRoot.dataset.token.trim();
      const rate = Number(bookingRoot.dataset.rate || 10);
      const minimum = Number(bookingRoot.dataset.minimum || 750);
      const input = name => bookingForm.elements.namedItem(name);
      input('vin')?.addEventListener('input', event => {
        event.target.value = event.target.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
      });
      ['pickup', 'destination'].forEach(name => input(name)?.addEventListener('input', () => {
        routeQuote = null;
        price.hidden = true;
        submit.disabled = true;
      }));

      const getJson = async (url, fallback) => {
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error(fallback);
        return response.json();
      };
      const geocode = async address => {
        const url = `https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(address)}&country=dk%2Cfr%2Cit&limit=1&access_token=${encodeURIComponent(token)}`;
        const data = await getJson(url, 'Adresseopslag fejlede.');
        const feature = data.features?.[0];
        if (!feature) throw new Error(`Kunne ikke finde adressen: ${address}`);
        return {
          coordinates: feature.geometry.coordinates,
          name: feature.properties?.full_address || feature.properties?.name || address
        };
      };
      calculate.addEventListener('click', async () => {
        message.textContent = '';
        receipt.hidden = true;
        const pickup = String(input('pickup').value || '').trim();
        const destination = String(input('destination').value || '').trim();
        if (!pickup || !destination) {
          message.textContent = 'Udfyld både afhentnings- og leveringsadresse.';
          return;
        }
        if (!token) {
          message.textContent = 'Prisberegningen er ikke konfigureret endnu.';
          return;
        }
        calculate.disabled = true;
        calculate.textContent = 'BEREGNER…';
        try {
          const [from, to] = await Promise.all([geocode(pickup), geocode(destination)]);
          const coordinates = `${from.coordinates.join(',')};${to.coordinates.join(',')}`;
          const directionsUrl = `https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}?exclude=ferry&overview=false&steps=false&access_token=${encodeURIComponent(token)}`;
          const directions = await getJson(directionsUrl, 'Ruteberegningen fejlede.');
          if (!directions.routes?.length) throw new Error('Ingen vej- eller brorute blev fundet uden færge.');
          const distanceKm = directions.routes[0].distance / 1000;
          const estimatedPrice = Math.max(minimum, distanceKm * rate);
          routeQuote = { pickup: from.name, destination: to.name, distanceKm, estimatedPrice };
          input('pickup').value = from.name;
          input('destination').value = to.name;
          bookingRoot.querySelector('[data-business-route]').textContent = `${from.name} → ${to.name}`;
          bookingRoot.querySelector('[data-business-distance]').textContent = `${distanceKm.toLocaleString('da-DK', { maximumFractionDigits: 1 })} km`;
          bookingRoot.querySelector('[data-business-amount]').textContent = `${Math.round(estimatedPrice).toLocaleString('da-DK')} kr.`;
          price.hidden = false;
          submit.disabled = false;
        } catch (error) {
          routeQuote = null;
          submit.disabled = true;
          message.textContent = error.message || 'Ruten kunne ikke beregnes.';
        } finally {
          calculate.disabled = false;
          calculate.textContent = 'BEREGN PRIS';
        }
      });

      bookingForm.addEventListener('submit', async event => {
        event.preventDefault();
        message.textContent = '';
        receipt.hidden = true;
        if (!bookingForm.reportValidity() || !routeQuote) {
          message.textContent = 'Udfyld formularen og beregn ruten først.';
          return;
        }
        const payload = bookingPayload();
        const fingerprint = JSON.stringify(payload);
        const storageKey = 'klinker-business-booking-v1';
        let pending;
        try { pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
        if (!pending || pending.fingerprint !== fingerprint) {
          pending = {
            fingerprint,
            idempotencyKey: crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`
          };
          try { sessionStorage.setItem(storageKey, JSON.stringify(pending)); } catch (_) {}
        }
        submit.disabled = true;
        calculate.disabled = true;
        submit.textContent = 'SENDER…';
        try {
          const data = await api('/bookings', {
            method: 'POST',
            body: { ...payload, idempotencyKey: pending.idempotencyKey }
          });
          receipt.replaceChildren(
            el('strong', '', `Forespørgsel ${data.reference} er modtaget.`),
            el('p', '', data.message || 'Vi kontakter dig, når transporten er planlagt.')
          );
          const open = el('a', 'btn primary', 'SE TRANSPORT');
          open.href = `#transport-${data.reference}`;
          receipt.append(open);
          receipt.hidden = false;
          message.textContent = 'Transporten er tilføjet til dit overblik.';
          try { sessionStorage.removeItem(storageKey); } catch (_) {}
          await loadDashboard(true);
        } catch (error) {
          const errors = {
            vin_required: 'VIN / stelnummer er påkrævet.',
            invalid_vin: 'VIN skal bestå af 17 gyldige tegn.',
            idempotency_conflict: 'Formularen er ændret. Prøv at sende igen.'
          };
          message.textContent = errors[error.message] || 'Forespørgslen kunne ikke sendes. Prøv igen.';
        } finally {
          submit.disabled = !routeQuote;
          calculate.disabled = false;
          submit.textContent = 'SEND FORESPØRGSEL';
        }
      });
    };

    const renderStage = (report, stage) => {
      const stageData = report.data?.[stage] || {};
      const section = el('section', 'kbl-doc-stage');
      section.append(el('h4', '', stage === 'before' ? 'Før afhentning' : 'Efter levering'));
      const values = el('div', 'kbl-doc-values');
      values.append(
        field('Kilometertal', Number.isInteger(stageData.mileage) ? stageData.mileage.toLocaleString('da-DK') + ' km' : '—'),
        field('Tilbehør', stageData.accessories || '—'),
        field('Noter / skader', stageData.notes || '—')
      );
      section.append(values);

      const media = (report.media || []).filter(item => item.stage === stage);
      if (!media.length) {
        section.append(el('p', 'kbl-doc-empty', 'Ingen billeder eller dokumenter registreret endnu.'));
        return section;
      }
      const gallery = el('div', 'kbl-gallery');
      media.forEach(item => {
        const href = `${proxyBase}/reports/${encodeURIComponent(report.reference)}/media/${encodeURIComponent(item.id)}`;
        const link = el('a', 'kbl-media');
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener';
        if (item.mime === 'application/pdf') {
          link.append(el('span', 'kbl-file-icon', 'PDF'), el('strong', '', labels[item.category] || 'Dokument'));
        } else {
          const image = el('img');
          image.src = href;
          image.alt = `${labels[item.category] || item.category} – ${stage === 'before' ? 'før' : 'efter'}`;
          image.loading = 'lazy';
          link.append(image, el('strong', '', labels[item.category] || item.category));
        }
        gallery.append(link);
      });
      section.append(gallery);
      return section;
    };

    const loadDocumentation = async (transport, container, button) => {
      if (container.dataset.loaded) {
        container.hidden = !container.hidden;
        button.setAttribute('aria-expanded', String(!container.hidden));
        return;
      }
      button.disabled = true;
      button.textContent = 'HENTER…';
      try {
        const data = await api(`/reports/${encodeURIComponent(transport.reference)}`);
        const report = data.report;
        container.replaceChildren();
        const top = el('div', 'kbl-doc-top');
        top.append(field('VIN / stelnummer', report.data?.vin || '—'), field('Senest gemt', report.updatedAt ? new Date(report.updatedAt).toLocaleString('da-DK') : '—'));
        container.append(top, renderStage(report, 'before'), renderStage(report, 'after'));
        container.dataset.loaded = 'true';
        container.hidden = false;
        button.setAttribute('aria-expanded', 'true');
      } catch (error) {
        container.replaceChildren(el('p', 'kbl-error', error.status === 404 ? 'Dokumentationen er ikke gjort tilgængelig endnu.' : 'Dokumentationen kunne ikke hentes. Prøv igen.'));
        container.hidden = false;
      } finally {
        button.disabled = false;
        button.textContent = 'SE DOKUMENTATION';
      }
    };

    const card = transport => {
      const article = el('article', 'kbl-card');
      article.id = `transport-${transport.reference}`;
      const head = el('div', 'kbl-card-head');
      const title = el('div');
      title.append(el('small', '', transport.reference), el('h3', '', transport.vehicle || 'Køretøj'));
      head.append(title, el('span', 'kbl-badge', transport.statusLabel || transport.status));
      const route = el('div', 'kbl-route');
      route.append(field('Afhentning', transport.pickup), field('Levering', transport.destination));
      const meta = el('div', 'kbl-meta');
      meta.append(
        field('Forventet afhentning', transport.schedule?.expectedPickup || 'Afventer planlægning'),
        field('Forventet levering', transport.schedule?.expectedDelivery || transport.eta || 'Afventer planlægning')
      );

      const details = el('div', 'kbl-details');
      details.hidden = true;
      details.append(
        field('VIN / stelnummer', transport.vin || '—'),
        field('Faktisk afhentning', transport.schedule?.actualPickedUp || '—'),
        field('Faktisk levering', transport.schedule?.actualDelivered || '—'),
        field('Ønsket afhentning', transport.booking?.requestedPickup || '—'),
        field('Estimeret afstand', Number.isFinite(transport.booking?.distanceKm) ? `${transport.booking.distanceKm.toLocaleString('da-DK')} km` : '—'),
        field('Beregnet pris', Number.isFinite(transport.booking?.estimatedPrice) ? `${Math.round(transport.booking.estimatedPrice).toLocaleString('da-DK')} kr.` : '—'),
        field('Senest opdateret', transport.updated || '—')
      );

      const actions = el('div', 'kbl-actions');
      const detailButton = el('button', 'btn', 'SE TRANSPORT');
      detailButton.type = 'button';
      detailButton.setAttribute('aria-expanded', 'false');
      detailButton.addEventListener('click', () => {
        details.hidden = !details.hidden;
        detailButton.setAttribute('aria-expanded', String(!details.hidden));
        detailButton.textContent = details.hidden ? 'SE TRANSPORT' : 'SKJUL TRANSPORT';
      });
      actions.append(detailButton);
      const tracking = el('a', 'btn', 'ÅBN TRACKING');
      tracking.href = `/pages/tracking?tracking=${encodeURIComponent(transport.reference)}`;
      actions.append(tracking);
      if (transport.status === 'delivered' && transport.documentation?.available) {
        const pdf = el('a', 'btn primary', 'DOWNLOAD LEVERINGSRAPPORT');
        pdf.href = `${proxyBase}/reports/${encodeURIComponent(transport.reference)}/delivery-pdf`;
        pdf.setAttribute('download', `${transport.reference}-leveringsrapport.pdf`);
        actions.append(pdf);
      } else if (transport.status !== 'delivered') {
        actions.append(el('span', 'kbl-doc-pending', 'Leveringsrapporten bliver tilgængelig efter levering.'));
      }
      const docs = el('div', 'kbl-docs');
      docs.hidden = true;
      if (transport.documentation?.available) {
        const docButton = el('button', 'btn primary', 'SE DOKUMENTATION');
        docButton.type = 'button';
        docButton.setAttribute('aria-expanded', 'false');
        docButton.addEventListener('click', () => loadDocumentation(transport, docs, docButton));
        actions.append(docButton);
      } else {
        actions.append(el('span', 'kbl-doc-pending', transport.documentationStatus || 'Dokumentation afventer'));
      }
      article.append(head, route, meta, details, actions, docs);
      return article;
    };

    const renderList = (items, container, countSelector, emptySelector) => {
      root.querySelector(countSelector).textContent = String(items.length).padStart(2, '0');
      root.querySelector(emptySelector).hidden = items.length !== 0;
      container.replaceChildren(...items.map(card));
    };

    const loadDashboard = async silent => {
      try {
        const data = await api('/transports');
        dashboardProfile = data.profile || {};
        if (bookingForm) {
          const setEmpty = (name, value) => {
            const input = bookingForm.elements.namedItem(name);
            if (input && !input.value && value) input.value = value;
          };
          setEmpty('customerName', dashboardProfile.name);
          setEmpty('company', dashboardProfile.company);
          setEmpty('phone', dashboardProfile.phone);
        }
        renderList(data.active || [], activeNode, '[data-business-active-count]', '[data-business-active-empty]');
        renderList(data.previous || [], previousNode, '[data-business-previous-count]', '[data-business-previous-empty]');
        statusNode.classList.remove('is-error');
        if (!silent) {
          statusNode.textContent = (data.active?.length || data.previous?.length)
            ? 'Dit transportoverblik er opdateret.'
            : 'Ingen transporter er knyttet til denne e-mail endnu.';
        }
      } catch (error) {
        statusNode.classList.add('is-error');
        statusNode.textContent = error.status === 401
          ? 'Din login-session kunne ikke bekræftes. Log ud og ind igen.'
          : 'Transporterne kunne ikke hentes lige nu. Prøv igen om lidt.';
      }
    };

    initBusinessBooking();
    loadDashboard(false);
  })();
  } catch(e) { console.error(e); }
})();

})();
